'use strict';

const Swiper = window.Swiper;

/**
 * Removes the whole recommender component (title, placeholder and spacing) from the page
 * @param {jQuery} $parentElement parent element where recommendations will show.
 */
function removeRecommender($parentElement) {
    $parentElement.spinner().stop();

    var $component = $parentElement.closest('.experience-einstein-einsteinCarousel, .experience-einstein-einsteinCarouselProduct, .experience-einstein-einsteinCarouselCategory, .experience-einstein-einsteinCarouselCompleteTheSet');
    if (!$component.length) {
        $component = $parentElement.closest('.experience-einstein-carousel');
    }

    ($component.length ? $component : $parentElement).remove();
}

/**
 * Validates and Return the cquotient namespace provided by the commerce cloud platform
 * @returns {Object} - einsteinUtils or null
 */
function getEinsteinUtils() {
    var einsteinUtils = window.CQuotient;
    if (einsteinUtils && (typeof einsteinUtils.getCQUserId === 'function') && (typeof einsteinUtils.getCQCookieId === 'function')) {
        return einsteinUtils;
    }
    return null;
}

/**
 * fills in the carousel with product tile html objects
 * @param {string} einsteinResponse string html for product tiles
 * @param {jQuery} $parentElement parent element where recommendations will show.
 */
function fillDomElement(einsteinResponse, $parentElement) {
    var recommender = $parentElement.data('recommender');
    var recommendedProducts = einsteinResponse && einsteinResponse[recommender] && einsteinResponse[recommender].recs;
    var carouselId = $parentElement[0].id;
    if (recommendedProducts && recommendedProducts.length > 0) {
        var template = $parentElement.data('template');
        var swatches = $parentElement.data('swatches');
        var components = [];
        components = recommendedProducts.map(function (recommendedProduct) {
            var tiledefinition = {};
            tiledefinition.classxs = $parentElement.data('bsxs');
            tiledefinition.classsm = $parentElement.data('bssm');
            tiledefinition.classmd = $parentElement.data('bsmd');
            tiledefinition.template = template;
            tiledefinition.swatches = swatches;
            tiledefinition.model = {
                type: 'product',
                id: recommendedProduct.id
            };
            return tiledefinition;
        });
        var extraSmallDisplay = $parentElement.data('xs');
        var smallDisplay = $parentElement.data('sm');
        var mediumDisplay = $parentElement.data('md');

        var url = new URL($parentElement.data('product-load-url'));
        url.searchParams.append('components', JSON.stringify(components));
        url.searchParams.append('limit', $parentElement.data('limit'));
        url.searchParams.append('recommender', recommender);
        $.ajax({
            url: url.href,
            type: 'get',
            dataType: 'html',
            success: function (html) {
                var alreadyLoaded = '.' + carouselId + '.swiper-initialized';

                if (!html || !html.trim()) {
                    removeRecommender($parentElement);
                    return;
                }

                if (!$(alreadyLoaded).length) {
                    $parentElement.parent().parent().find('.carousel-title').removeClass('hidden');
                    $parentElement.find('.' + carouselId + ' .swiper-wrapper').html(html);

                    new Swiper('.' + carouselId, {
                        // Optional parameters
                        slidesPerView: extraSmallDisplay,
                        spaceBetween: 20,
                        grabCursor: true,
                        autoHeight: false,
                        speed: 500,
                        enabled: false,

                        breakpoints: {
                            768: {
                                slidesPerView: smallDisplay,
                            },
                            1024: {
                                slidesPerView: mediumDisplay,
                                enabled: true,

                                // If we need pagination
                                pagination: {
                                    el: '#' + carouselId + ' .swiper-pagination',
                                    clickable: true,
                                },

                                // Navigation arrows
                                navigation: {
                                    nextEl: '#' + carouselId + ' .swiper-button-next',
                                    prevEl: '#' + carouselId + ' .swiper-button-prev',
                                },
                            },
                        },
                    });
                }
            },
            error: function () {
                removeRecommender($parentElement);
            }
        });
    } else {
        removeRecommender($parentElement);
    }
}

/**
 * Processes a recommendation tile, with an already initialized category specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @param {Object} einsteinUtils cquotient object
 * @param {Array} anchorsArray array of objects representing anchors
*/
function processRecommendationsTile($parentElement, einsteinUtils, anchorsArray) {
    var recommender = $parentElement.data('recommender');

    var params = {
        userId: einsteinUtils.getCQUserId(),
        cookieId: einsteinUtils.getCQCookieId(),
        ccver: '1.01'
    };

    if (anchorsArray) {
        params.anchors = anchorsArray;
    }

    /**
    * Processes a recommendation responses
    * @param {Object} einsteinResponse cquotient object
    */
    function recommendationsReceived(einsteinResponse) {
        fillDomElement(einsteinResponse, $parentElement);
        $parentElement.spinner().stop();
    }

    if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
    } else {
        einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
        einsteinUtils.widgets.push({
            recommenderName: recommender,
            parameters: params,
            callback: recommendationsReceived
        });
    }
}

/**
 * Processes a recommendation tile, with an already initialized product specific anchors array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createProductAnchor($parentElement) {
    return [{
        id: $parentElement.data('primaryProductId'),
        sku: $parentElement.data('secondaryProductId'),
        type: $parentElement.data('alternativeGroupType'),
        alt_id: $parentElement.data('alternativeGroupId')
    }];
}

/**
 * Rerieves data attributes from parent element and converts to gretel compatible recommenders array
 * @param {jQuery} $parentElement parent element where recommendations will show.
 * @returns {Array} - containing an anchor object
 */
function createCategoryAnchor($parentElement) {
    return [{ id: $parentElement.data('categoryId') }];
}

/**
 * Removes the queued recommenders when the einstein script failed to load. The script is loaded async,
 * so it has either loaded or failed by window load. Tracking prevention (e.g. Safari Private Browsing)
 * blocks it, in which case the queued callbacks are never called and the placeholders would load forever.
 * @param {Object} einsteinUtils cquotient object
 * @param {jQuery} $recommendationTiles parent elements where recommendations will show.
 */
function removeWhenEinsteinBlocked(einsteinUtils, $recommendationTiles) {
    var check = function () {
        if (!einsteinUtils.getRecs) {
            $recommendationTiles.each(function () {
                removeRecommender($(this));
            });
        }
    };

    if (document.readyState === 'complete') {
        check();
    } else {
        window.addEventListener('load', check);
    }
}

/**
 * Gets all placeholder elements, which hold einstein recommendations queries the details from the
 * einstein engine and feeds them back to the dom element
 */
function loadRecommendations() {
    var einsteinUtils = getEinsteinUtils();
    var $recommendationTiles = $('.einstein-carousel');
    if (!einsteinUtils) {
        $recommendationTiles.each(function () {
            removeRecommender($(this));
        });
    } else {
        $recommendationTiles.each(function () {
            var $parentElement = $(this);
            // This script is printed once per Page-Include. A second run would request every carousel again.
            if ($parentElement.data('einsteinRequested')) {
                return;
            }
            $parentElement.data('einsteinRequested', true);
            $parentElement.spinner().start();
            if ($(this).closest('.experience-einstein-einsteinCarouselProduct').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
            } else if ($(this).closest('.experience-einstein-einsteinCarouselCategory').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createCategoryAnchor($parentElement));
            } else if ($(this).closest('.experience-einstein-einsteinCarouselCompleteTheSet').length) {
                return processRecommendationsTile($parentElement, einsteinUtils, createProductAnchor($parentElement));
            }
            return processRecommendationsTile($parentElement, einsteinUtils);
        });

        if (!einsteinUtils.getRecs) {
            removeWhenEinsteinBlocked(einsteinUtils, $recommendationTiles);
        }
    }
}

// Page-Include emits this file from each recommendation region, so bind once.
if (!window.einsteinCarouselInitialized) {
    window.einsteinCarouselInitialized = true;
    $(document).ready(function () {
        loadRecommendations();
    });
}
